import "../styles/OrdersPage.css";

import OrdersHeader from "../components/OrdersHeader/OrdersHeader";
import OrdersStats from "../components/OrdersStats/OrdersStats";
import OrdersToolbar from "../components/OrdersToolbar/OrdersToolbar";
import OrdersTable from "../components/OrdersTable/OrdersTable";

import useOrders from "../hooks/useOrders";
import useOrderFilters from "../hooks/useOrderFilters";

function OrdersPage() {
  const {
    orders,
    loading,
    fetchOrders,
    updateStatus,
  } = useOrders();

  const {
    search,
    setSearch,
    status,
    setStatus,
    filteredOrders,
  } = useOrderFilters(orders);

  if (loading) {
    return (
      <div className="orders-loading">
        Loading Orders...
      </div>
    );
  }

  return (
    <div className="orders-page">
      <OrdersHeader onRefresh={fetchOrders} />

      <OrdersStats orders={orders} />

      <OrdersToolbar
        search={search}
        setSearch={setSearch}
        status={status}
        setStatus={setStatus}
        refreshOrders={fetchOrders}
      />

      <OrdersTable
        orders={filteredOrders}
        updateStatus={updateStatus}
      />
    </div>
  );
}

export default OrdersPage;